/* import React, { useState, useCallback } from 'react';
import Layout from '../../components/layout/Layout';
import Card from '../../components/card/Card';
import Table from '../../components/table/Table';
import TestataOrdine from '../../components/table/TestataOrdine';
import FiltriTestataOrdine from '../../components/form/FiltriTestateOrdini';
import { WSREST_TABATA } from '../../config';
import { getMerlinoT } from '../../services/merlinoService';


function ElencoOrdini() {

    const [filters, setFilters] = useState({});
    const tableHeader = ["Stato", "Id Ordine", "Data ordine", "Nome", "Cognome", "Indirizzo", "Totale omaggio", "Totale da pagare", "Totale pagato"];

    const handleFilterChange = (newFilters) => {
        setFilters(newFilters);
    };

    const fetchData = useCallback(async () => {
        const url = WSREST_TABATA;
        const token = getMerlinoT();

        // Costruisce il payload con i filtri
        const payload = {
            idordine: filters.IDOrdine || undefined,
            data_inizio: filters.DataInizio || undefined,
            data_fine: filters.DataFine || undefined,
            nome: filters.Nome || undefined,
            cognome: filters.Cognome || undefined
        };

        try {
            const response = await fetch(`${url}ordertabb2c/getTestate`, {
                method: 'POST',
                headers: {
                    'Authorization': 'Bearer ' + token,
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify(payload)
            });

            if (response.ok) {
                return await response.json();
            } else {
                console.error("Errore nella risposta:", response.status);
                return [];
            }
        } catch (error) {
            console.error("Errore durante la fetch:", error);
            return [];
        }
    }, [filters]);


    return ( 
        <>
            <FiltriTestataOrdine onFilterChange={handleFilterChange} />
            <Card titoloCard='Ordini'>   
                <Table ComponentDaRenderizzare={TestataOrdine} fetchData={fetchData} tableHeader={tableHeader} />
            </Card>
        </>
    );
}

export default ElencoOrdini; */
import React, { useState, useCallback } from 'react';
import Card from '../../components/card/Card';
import Table from '../../components/table/Table';
import TestataOrdine from '../../components/table/TestataOrdine';
import FiltriTestataOrdine from '../../components/form/FiltriTestateOrdini';
import { WSREST_TABATA } from '../../config';
import { getMerlinoT } from '../../services/merlinoService';

function ElencoOrdini() {
    const today = new Date();
    const thirtyDaysAgo = new Date();
    thirtyDaysAgo.setDate(today.getDate() - 30);

    const formatDate = (date) => date.toISOString().split('T')[0];

    const [filters, setFilters] = useState({
        DataInizio: formatDate(thirtyDaysAgo),
        DataFine: formatDate(today)
    });

    const [selectedTab, setSelectedTab] = useState('open');
    const [showFilteredTable, setShowFilteredTable] = useState(false);

    const tableHeader = [
        "Stato",
        "Id Ordine",
        "Data ordine",
        "Num. ordine gestionale",
        "Nome",
        "Cognome",
        "Indirizzo",
        "Totale omaggio",
        "Totale da pagare",
        "Totale pagato"
    ];

    const handleFilterChange = (newFilters) => {
        setFilters(prev => ({
            ...prev,
            ...newFilters
        }));
        setShowFilteredTable(true); // nascondi la prima tabella, mostra la seconda
    };

    const handleResetFilters = () => {
        setShowFilteredTable(false); // mostra la prima tabella, nascondi la seconda
    };

    const handleTabChange = (tab) => {
        setSelectedTab(tab);
    };

    const fetchData = useCallback(async () => {
        const url = WSREST_TABATA;
        const token = getMerlinoT();

        const payload = {
            idordine: filters.IDOrdine || undefined,
            data_inizio: filters.DataInizio || undefined,
            data_fine: filters.DataFine || undefined,
            nome: filters.Nome || undefined,
            cognome: filters.Cognome || undefined,
            stato: selectedTab
        };

        try {
            const response = await fetch(`${url}ordertabb2c/getTestate`, {
                method: 'POST',
                headers: {
                    'Authorization': 'Bearer ' + token,
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify(payload)
            });

            if (response.ok) {
                return await response.json();
            } else {
                console.error("Errore nella risposta:", response.status);
                return [];
            }
        } catch (error) {
            console.error("Errore durante la fetch:", error);
            return [];
        }
    }, [filters, selectedTab]);

    const fetchDataFiltered = useCallback(async () => {
        const url = WSREST_TABATA;
        const token = getMerlinoT();

        const payload = {
            idordine: filters.IDOrdine || undefined,
            data_inizio: filters.DataInizio || undefined,
            data_fine: filters.DataFine || undefined,
            nome: filters.Nome || undefined,
            cognome: filters.Cognome || undefined,
            stato: "all" // 👈 forza lo stato su "all" per includere tutto
        };

        try {
            const response = await fetch(`${url}ordertabb2c/getTestate`, {
                method: 'POST',
                headers: {
                    'Authorization': 'Bearer ' + token,
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify(payload)
            });

            if (response.ok) {
                return await response.json();
            } else {
                console.error("Errore nella risposta:", response.status);
                return [];
            }
        } catch (error) {
            console.error("Errore durante la fetch:", error);
            return [];
        }
    }, [filters]);


    return (
        <>
            <FiltriTestataOrdine
                onFilterChange={handleFilterChange}
                onResetFilters={handleResetFilters}
                initialFilters={filters}
            />

            {!showFilteredTable && (
                <Card titoloCard="Ordini">
                    <ul className="nav nav-tabs mb-3">
                        <li className="nav-item">
                            <button
                                className={`nav-link ${selectedTab === 'open' ? 'active' : ''}`}
                                onClick={() => handleTabChange('open')}
                                type="button"
                            >
                                Ordini Aperti
                            </button>
                        </li>
                        <li className="nav-item">
                            <button
                                className={`nav-link ${selectedTab === 'closed' ? 'active' : ''}`}
                                onClick={() => handleTabChange('closed')}
                                type="button"
                            >
                                Ordini Spediti
                            </button>
                        </li>
                    </ul>

                    <Table
                        ComponentDaRenderizzare={TestataOrdine}
                        fetchData={fetchData}
                        tableHeader={tableHeader}
                    />
                </Card>
            )}

            {showFilteredTable && (
                <Card titoloCard="Ordini">
                    <Table
                        ComponentDaRenderizzare={TestataOrdine}
                        fetchData={fetchDataFiltered}
                        tableHeader={tableHeader}
                    />
                </Card>
            )}
        </>
    );
}

export default ElencoOrdini;


